import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { class: "sidebar-nav" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _withDirectives(_createElementVNode("select", {
      class: "sidebar-select",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItem) = $event)),
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSelect && _ctx.handleSelect(...args)))
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("option", {
        value: "",
        disabled: "",
        selected: ""
      }, "Navigate...", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
        return (_openBlock(), _createElementBlock("option", {
          key: item.label,
          value: item.url
        }, _toDisplayString(item.label), 9, _hoisted_2))
      }), 128))
    ], 544), [
      [_vModelSelect, _ctx.selectedItem]
    ]),
    _createElementVNode("nav", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item) => {
        return (_openBlock(), _createElementBlock("button", {
          key: item.label,
          type: "button",
          class: "sidebar-button",
          onClick: ($event: any) => (item.internal ? _ctx.navigate(item.url) : _ctx.newWindow(item.url))
        }, [
          _createElementVNode("img", {
            src: item.iconUrl,
            alt: item.label + ' icon',
            class: "sidebar-icon"
          }, null, 8, _hoisted_5),
          _createElementVNode("span", null, _toDisplayString(item.label), 1)
        ], 8, _hoisted_4))
      }), 128))
    ])
  ]))
}